import { ItemStock } from "@coworker/apprestructured/src/shared/components/item-cards/ItemStock/ItemStock";
import { ItemEds } from "@coworker/apprestructured/src/shared/components/item-cards/ItemEds/ItemEds";
import styles from "./item-stock-and-eds.module.css";

interface ItemStockAndEDSProps {
  itemNo: string;
  itemType: string;
}

export const ItemStockAndEds = ({ itemNo, itemType }: ItemStockAndEDSProps) => {
  return (
    <div className={styles["item-stock-eds-container"]}>
      <ItemStock itemNo={itemNo} itemType={itemType} />
      <ItemEds itemNo={itemNo} />
    </div>
  );
};
